import { defineComponent as d, computed as o, openBlock as c, createElementBlock as i, createElementVNode as e, toDisplayString as n, createCommentVNode as _, normalizeStyle as h } from "vue";
const f = ["viewBox"], u = /* @__PURE__ */ e("mask", { id: "4de7c4ca-d503-45ce-ad38-b8e0f25a06b0" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), m = { mask: "url(#4de7c4ca-d503-45ce-ad38-b8e0f25a06b0)" }, k = { key: 0 }, p = /* @__PURE__ */ e("path", {
  fill: "#0052b4",
  d: "m0 167 256-32 256 32v178l-256 32L0 345Z"
}, null, -1), v = /* @__PURE__ */ e("path", {
  fill: "#d80027",
  d: "M0 345h512v167H0Z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#6da544",
  d: "M0 0h512v167H0Z"
}, null, -1), x = { fill: "none" }, w = ["r"], B = /* @__PURE__ */ d({
  __name: "ru-da",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(a) {
    const t = a, l = o(() => 512 + 2 * t.strokeWidth), s = o(() => -t.strokeWidth), r = o(() => 256 + t.strokeWidth / 2);
    return (y, W) => (c(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      u,
      e("g", m, [
        t.flagName ? (c(), i("title", k, n(t.flagName), 1)) : _("", !0),
        p,
        v,
        g
      ]),
      e("g", x, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: h({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, w)
      ])
    ], 8, f));
  }
});
export {
  B as default
};
//# sourceMappingURL=ru-da-1388b868.js.map
